<template>
  <v-footer color="white" app inset absolute padless >
    <v-card flat tile class="text-center" style="width:100%;">
      <v-card-text class="font-weight-bold text-wrap">        
        <p style="word-wrap: break-word;">
        <a href="https://www.getkobe.com/influencer-terms-use-agreement/" target="_blank">
          Influencer Terms & Conditions
        </a><br/><br/>
        Website
        <a href="https://getkobe.com/website-terms-use" target="_blank">Terms of Use</a> and
        <a href="https://getkobe.com/website-privacy-policy" target="_blank">Privacy Policy.</a><br/><br/>
          Patent: <a href="https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1" target="_blank"> KOBE 11201807777W ℗ </a>
        <br/><br/>
        All rights reserved. Copyright &copy; 2016-{{year}}
        <a href="https://www.getkobe.com/" target="_blank"> Kobe Global Technologies Pte Ltd</a>.
        </p>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  name: 'CoreFooter',
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>



// WEBPACK FOOTER //
// FooterDense.vue?27bdb45c